import { useParams, useNavigate } from "react-router-dom";
import { VideoPlayer } from "./VideoPlayer";

export const VideoPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <VideoPlayer videoId={Number(id)} onClose={() => navigate(-1)} />
    </div>
  );
};
